import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useUserInfo() {
  const queryKey = ['userInfo'];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const userInfo = await api.get('userinfo', { signal }).json();

      return {
        ...userInfo,
        briefingRole: userInfo?.authorisation?.briefingRole ?? 'NONE',
      };
    },
    placeholderData: {
      briefingRole: 'NONE',
    },
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
